import { render, staticRenderFns } from "./form-image.vue?vue&type=template&id=6bb2d9ac&scoped=true&"
import script from "./form-image.vue?vue&type=script&lang=js&"
export * from "./form-image.vue?vue&type=script&lang=js&"
import style0 from "./form-image.vue?vue&type=style&index=0&id=6bb2d9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2d9ac",
  null
  
)

export default component.exports